import useExperimentsAnalytics from './hooks/useExperimentsAnalytics';

/**
 * We set this up as a React component, which allows us access experiments using hooks.
 *
 * @constructor
 */
const ExperimentsAnalytics = ({ children }) => {
  useExperimentsAnalytics();

  return children;
};

export default ExperimentsAnalytics;
